import React from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { ErrorFallback } from './ErrorFallback';

const logErrorToDatadog = (error: Error, info: React.ErrorInfo) => {
  datadogLogs.logger.error('ErrorBoundary caught an error', {
    error,
    componentStack: info.componentStack || 'No component stack available',
  });
};

export function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ReactErrorBoundary FallbackComponent={() => ErrorFallback({})} onError={logErrorToDatadog}>
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundary;
